import React from 'react';
import { usePermissions } from '@pankod/refine-core';
import { IResourceComponentsProps } from '@pankod/refine-core';
import {
  List,
  DateField,
  Table,
  useTable,
  EditButton,
  ShowButton,
  DeleteButton,
  Space,
} from '@pankod/refine-antd';

import { UserTypes } from 'interfaces';
import { USER_ROLES } from 'constant';

const UsersList: React.FC<IResourceComponentsProps> = () => {
  const { data: permissionsData } = usePermissions();
  const { tableProps } = useTable<UserTypes>({
    initialSorter: [
      {
        field: 'name',
        order: 'desc',
      },
    ],
    metaData: {
      fields: ['id', 'name', 'email', 'role', 'createdAt'],
    },
  });

  return (
    <List canCreate={permissionsData?.role === USER_ROLES.SUPER_ADMIN}>
      <Table {...tableProps} rowKey='id'>
        <Table.Column key='id' dataIndex='id' title='ID' />
        <Table.Column
          key='name'
          dataIndex='name'
          title='Name'
          sorter={{ multiple: 1 }}
        />
        <Table.Column key='email' dataIndex='email' title='Email' />

        <Table.Column
          dataIndex='createdAt'
          title='CreatedAt'
          render={(createdAt) => <DateField format='LLL' value={createdAt} />}
        />

        <Table.Column<UserTypes>
          title='Actions'
          dataIndex='actions'
          render={(_, record) => (
            <Space>
              {permissionsData?.role === USER_ROLES.SUPER_ADMIN && (
                <EditButton hideText size='small' recordItemId={record.id} />
              )}

              <ShowButton hideText size='small' recordItemId={record.id} />
              {permissionsData?.role === USER_ROLES.SUPER_ADMIN && (
                <DeleteButton hideText size='small' recordItemId={record.id} />
              )}
            </Space>
          )}
        />
      </Table>
    </List>
  );
};

export default UsersList;
